export default __webpack_public_path__ + "static/media/ConnectionAnimation.94526b4f.riv";